import { useMemo } from 'react';
import { transformToDetailedFlowData } from './detailedFlowchartUtils';
import { BaseFlowchart } from './BaseFlowchart';

const LEGEND_ITEMS = [
  { type: 'value', label: 'Values' },
  { type: 'competency', label: 'Competencies' },
  { type: 'action', label: 'Actions' },
  { type: 'entry', label: 'Skills/Entries' },
];

export function DetailedFlowchartView({ values, direction = 'LR' }) {
  // Transform data with memoization
  const { nodes, edges } = useMemo(() => {
    if (!values || values.length === 0) {
      return { nodes: [], edges: [] };
    }
    return transformToDetailedFlowData(values, direction);
  }, [values, direction]);

  if (!values || values.length === 0) {
    return (
      <div className="flowchart-empty">
        <p>No data available to display flowchart.</p>
      </div>
    );
  }

  return (
    <BaseFlowchart
      nodes={nodes}
      edges={edges}
      direction={direction}
      legendItems={LEGEND_ITEMS}
      className="flowchart-detailed"
    />
  );
}
